import { render, staticRenderFns } from "./RectangleRadio.vue?vue&type=template&id=9a8ac49a&lang=pug&"
import script from "./RectangleRadio.vue?vue&type=script&lang=js&"
export * from "./RectangleRadio.vue?vue&type=script&lang=js&"
import style0 from "./RectangleRadio.vue?vue&type=style&index=0&id=9a8ac49a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports